import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formValueSelector, getFormMeta, touch } from 'redux-form';
import { BaseCrud, FormSection, FormSectionColumn } from 'react/containers/layout/Crud';
import {
  TextField, LookupField, TextAreaField, GroupField, DecimalField, RadioGroupField
} from 'react/components/fields';
import PropTypes from 'prop-types';
import { List } from 'immutable';

class PendingOrderCrud extends Component {
  constructor(props) {
    super(props);

    App.Forms.PendingOrder = App.Forms.PendingOrder || {};
    App.Forms.PendingOrder.customColumns = this.getCustomColumns();
    App.Forms.PendingOrder.customProjection = {
      filters: [
        'id',
        'organization.id',
        'organization.description',
        'location.*',
        'createdDate',
        'number',
        'orderType',
        'specialInstructions'
      ],
      firstResult: 0,
      maxResults: 51
    };

    App.Objects.PendingOrder.beforeList = () => {
      App.Forms.PendingOrder.filterBuilder.setCallbackBeforeFilter(function setCustomFilters() {
        this.criteriaChain.criteriaChain[0].and = this.criteriaChain.criteriaChain[0].and.concat([
          {
            attr: 'assignedBy',
            isNull: true
          },
          {
            attr: 'assignedDate',
            isNull: true
          },
          {
            attr: 'assignedOrder',
            isNull: true
          }
        ]);
      });
    };
  }

  getCustomColumns = () => {
    App.Objects.PendingOrder.onClickOpenPendingOrderOnMap = (event, pendingOrderId) => {
      event.stopPropagation();
      event.preventDefault();
      const { openTabs } = this.props;
      const pendingOrders = App.Forms.PendingOrder.dataProvider.getItems();
      const { model } = pendingOrders.find((item) => item.idOfObject === pendingOrderId);
      const routeMonitorIsOpen = openTabs.find((item) => item.get('key') === 'RouteMonitor');

      if (model) {
        window.location = '#/RouteMonitor';

        const time = routeMonitorIsOpen ? 0 : 1500;
        setTimeout(() => {
          const RouteMonitorRoutes = new Greenmile.RouteMonitor.Routes();
          RouteMonitorRoutes.focusPendingOrderOnMap(model);
        }, time);
      }
    };

    App.Objects.PendingOrder.onClickShowSuggestRoutePendingOrderModal = (event, pendingOrderId) => {
      event.stopPropagation();
      event.preventDefault();
      const pendingOrders = App.Forms.PendingOrder.dataProvider.getItems();
      const { model } = pendingOrders.find((item) => item.idOfObject === pendingOrderId);

      if (model) {
        App.Views.RouteSuggestion.showModalFilter(model, '#PendingOrder', '.gmTabs__panel.is-active');
      }
    };

    return ([
      {
        id: 'openModal',
        name: '',
        field: '',
        width: 40,
        cssClass: 'cell-row custom-column',
        sortable: false,
        resizable: false,
        selectable: false,
        formatter: (row, cell, value, columnDef, dataContext) => {
          const pendingOrderId = dataContext.model.get('id');
          return `
            <button
              type="button"
              onclick="App.Objects.PendingOrder.onClickShowSuggestRoutePendingOrderModal(event, ${pendingOrderId})"
              class="custom-column-icon suggestRoute"
              title="${Monet.I18n.getResourcesByKey('PendingOrder.column.suggestRoute')}"
            ></button>
          `;
        }
      },
      {
        id: 'viewOnMap',
        name: '',
        field: '',
        width: 40,
        cssClass: 'cell-row custom-column',
        sortable: false,
        resizable: false,
        selectable: false,
        formatter: (row, cell, value, columnDef, dataContext) => {
          const pendingOrderId = dataContext.model.get('id');
          return `
            <button
              type="button"
              onclick="App.Objects.PendingOrder.onClickOpenPendingOrderOnMap(event, ${pendingOrderId})"
              class="custom-column-icon openOnMap"
              title="${Monet.I18n.getResourcesByKey('PendingOrder.column.openOnMap')}"
            ></button>
          `;
        }
      }
    ]);
  };

  // Get order type based on the planned sizes values, since the order type
  // field is not filled when creating a Pending Order through TFI or API
  getOrderType = () => {
    const { initialLineItems } = this.props;
    const lineItems = initialLineItems.toJSON();
    if (lineItems.length) {
      const isPickup = lineItems.some((lineItem) => (
        Object.keys(lineItem).find((key) => (
          ['plannedPickupSize1', 'plannedPickupSize2', 'plannedPickupSize3'].includes(key)
        ))
      ));
      return isPickup ? 'PICKUP' : 'DELIVERY';
    }
    return undefined;
  }

  renderGeneralSection = () => {
    const { id, isGrid } = this.props;
    const isEditPage = !!id && !isGrid;

    return (
      <FormSection title="PendingOrder.section.general.title">
        <FormSectionColumn>
          <LookupField
            label="PendingOrder.field.organization"
            name="organization"
            lookupEntity="Organization"
            lookupEntityColumn="description"
            disabledOnEdit
            required
          />
          <TextField
            label="PendingOrder.field.number"
            name="number"
            maxLength={45}
            disabledOnEdit
            required
          />
          <LookupField
            label="PendingOrder.field.location"
            name="location"
            lookupEntity="Location"
            lookupEntityColumn="description"
            required
          />
          <RadioGroupField
            name="orderType"
            label="PendingOrder.field.orderType"
            defaultValue="DELIVERY"
            options={[
              {
                label: 'PendingOrder.field.orderType.delivery',
                value: 'DELIVERY'
              },
              {
                label: 'PendingOrder.field.orderType.pickup',
                value: 'PICKUP'
              }
            ]}
            value={this.getOrderType()}
            disabled={isEditPage}
          />
        </FormSectionColumn>
        <FormSectionColumn>
          <TextAreaField
            label="PendingOrder.field.specialInstructions"
            name="specialInstructions"
          />
        </FormSectionColumn>
      </FormSection>
    );
  };

  renderModalContainerSection = () => (
    <div className="modalContainer" />
  );

  getSizesNames = () => {
    const { orderType } = this.props;
    if (orderType === 'PICKUP') {
      return ['plannedPickupSize1', 'plannedPickupSize2', 'plannedPickupSize3'];
    }
    return ['plannedSize1', 'plannedSize2', 'plannedSize3'];
  };

  validateSizeField = (value, { lineItems }, { name }) => {
    const { fieldsMeta: { lineItems: lineItemsMeta }, touchAction } = this.props;
    const [plannedSize1Name, plannedSize2Name, plannedSize3Name] = this.getSizesNames();
    const index = name.match(/lineItems\[(\d+)\]/)[1];
    const isInvalid = lineItems[index]
      && !lineItems[index][plannedSize1Name]
      && !lineItems[index][plannedSize2Name]
      && !lineItems[index][plannedSize3Name];

    if (isInvalid) {
      if (lineItemsMeta) {
        const plannedSizesMeta = Object.entries(lineItemsMeta[index] || {}).filter(([key]) =>
          key === plannedSize1Name || key === plannedSize2Name || key === plannedSize3Name
        );
        if (plannedSizesMeta.filter(([, { touched }]) => touched).length < 3
          && !plannedSizesMeta.find(([, { active, touched }]) => active && !touched)
          && plannedSizesMeta.find(([, { visited }]) => visited)) {
          touchAction(
            'PendingOrder',
            `lineItems[${index}].${plannedSize1Name}`,
            `lineItems[${index}].${plannedSize2Name}`,
            `lineItems[${index}].${plannedSize3Name}`
          );
        }
      }
      return Monet.I18n.getResourcesByKey('PendingOrder.error.plannedSizeRequired');
    }
    return undefined;
  };

  renderOrderItemsSection = () => {
    const { orderType } = this.props;


    return (
      <FormSection
        title="PendingOrder.section.orderItems.title"
        className="section-orderItems"
      >
        <FormSectionColumn>
          <GroupField name="lineItems">
            <LookupField
              label="OrderItem.field.sku"
              name="sku"
              lookupEntity="Sku"
              lookupEntityColumn="description"
              required
            />
            <DecimalField
              label="OrderItem.field.planned1"
              name="plannedSize1"
              shouldShow={orderType === 'DELIVERY'}
              customValidation={this.validateSizeField}
            />
            <DecimalField
              label="OrderItem.field.planned2"
              name="plannedSize2"
              shouldShow={orderType === 'DELIVERY'}
              customValidation={this.validateSizeField}
              noFieldMessage
            />
            <DecimalField
              label="OrderItem.field.planned3"
              name="plannedSize3"
              shouldShow={orderType === 'DELIVERY'}
              customValidation={this.validateSizeField}
              noFieldMessage
            />
            <DecimalField
              label="OrderItem.field.planned1"
              name="plannedPickupSize1"
              shouldShow={orderType === 'PICKUP'}
              customValidation={this.validateSizeField}
            />
            <DecimalField
              label="OrderItem.field.planned2"
              name="plannedPickupSize2"
              shouldShow={orderType === 'PICKUP'}
              customValidation={this.validateSizeField}
              noFieldMessage
            />
            <DecimalField
              label="OrderItem.field.planned3"
              name="plannedPickupSize3"
              shouldShow={orderType === 'PICKUP'}
              customValidation={this.validateSizeField}
              noFieldMessage
            />
          </GroupField>
        </FormSectionColumn>
      </FormSection>
    );
  }



  render() {
    return (
      <BaseCrud
        tabName="PendingOrder.title"
        updateMethod="POST"
        {...this.props}
      >
        {this.renderModalContainerSection()}
        {this.renderGeneralSection()}
        {this.renderOrderItemsSection()}
      </BaseCrud>
    );
  }
}

PendingOrderCrud.propTypes = {
  openTabs: PropTypes.object.isRequired,
  initialLineItems: PropTypes.object,
  orderType: PropTypes.string,
  touchAction: PropTypes.func.isRequired,
  fieldsMeta: PropTypes.object
};

PendingOrderCrud.defaultProps = {
  initialLineItems: null,
  orderType: null,
  fieldsMeta: {}
};

const valueSelector = formValueSelector('PendingOrder');
const metaSelector = getFormMeta('PendingOrder');

const mapStateToProps = (state) => ({
  openTabs: state.tabs.get('list'),
  initialLineItems: state.crud.getIn(['PendingOrder', 'initialValues', 'lineItems'], List()),
  orderType: valueSelector(state, 'orderType'),
  lineItems: valueSelector(state, 'lineItems'),
  fieldsMeta: metaSelector(state)
});

const mapDispatchToProps = {
  touchAction: touch
};

export default connect(mapStateToProps, mapDispatchToProps)(PendingOrderCrud);
